/// <amd-module name="typeahead/core/plugins/SuggestionsProvider" />
/// <amd-dependency path="jquery" name="$"/>

/// <reference path="../../../typings/typeahead/plugins.d.ts"/>
/// <reference path="../../../typings/typeahead/suggestionsProvider.d.ts"/>
/// <reference path="../../../typings/typeahead/browser.d.ts" />

import {DefaultPluginAssembly} from "typeahead/core/plugins/DefaultPluginAssembly";

export class SuggestionsProvider {
    private suggestionsModifiers: ISuggestionsModifier[] = [];

    constructor(pluginAssembly: IPluginAssembly) {
        this.suggestionsModifiers = pluginAssembly.get(DefaultPluginAssembly.suggestionsModifierIdentifier);
    }

    public modifySuggestions(results: Object[], context: IContext, options: any = {}): Object[] {
        if (results && results.length > 0 && this.suggestionsModifiers && this.suggestionsModifiers.length > 0) {
            this.suggestionsModifiers.map((suggestionsModifier: ISuggestionsModifier) => {
                return suggestionsModifier.modifySuggestions(results, context, options);
            });
            return results;
        }
        return [];
    }
}
